window.globalHelpersModule.directive "creationDenied", 
['$rootScope', '$log', '$timeout', '$filter', '$state', 'AuthService',
($rootScope, $log, $timeout, $filter, $state, AuthService) ->
  restrict: "E"
  scope:
    feedItem: "="
  link: (scope, element, attrs) ->

  templateUrl: 'portal/appointments/feed-items/creation_denied/creation_denied-directive-template.html'
]